export default "__VITE_ASSET__CbDHgXmV__"